module.exports = __webpack_public_path__ + "img/auto-deposits-icon.ed0df3c1.png";